<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-maintenance-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Form.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Form.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <form class="zn-form" [formGroup]="form">
        <div class="row">
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="standDivisionAndFusionMaintenancePeriod">
                {{ 'LanguageService::Stand.MaintenancePeriod' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                id="standDivisionAndFusionMaintenancePeriod"
                [optionsLoader]="loadPeriod"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="period"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('period')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="standDivisionAndFusionMaintenanceReason">
                {{ 'LanguageService::Stand.MaintenanceReason' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                id="standDivisionAndFusionMaintenanceReason"
                [optionsLoader]="loadReason"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="reason"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('reason')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="standDivisionAndFusionMaintenanceAdjustmentType">
                {{ 'LanguageService::Stand.AdjustmentType' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                id="standDivisionAndFusionMaintenanceAdjustmentType"
                [optionsLoader]="loadAdjustmentTypes"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="adjustmentType"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('adjustmentType')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-10">
            <div class="form-control-container">
              <label class="form-label" for="standDivisionAndFusionMaintenanceDetails">
                {{ 'LanguageService::StandAreaMaintenance.Notes' | abpLocalization }}
              </label>
              <input
                id="standDivisionAndFusionMaintenanceDetails"
                class="form-control"
                type="text"
                formControlName="details"
                [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
              />
            </div>
          </div>
          <div class="col-2">
            <div class="form-control-container">
              <label
                class="form-label form-check-label"
                [class.text-muted]="form.get('isAreaUpdated')?.disabled"
                for="standDivisionAndFusionMaintenanceUpdated"
              >
                {{ `${localizationResource}::Stand.UpdatedArea` | abpLocalization }}
                <span
                  class="form-label-required"
                  [class.text-muted]="form.get('isAreaUpdated')?.disabled"
                >*</span>
              </label>
              <div class="form-check-inner-container order-first">
                <input
                  id="standDivisionAndFusionMaintenanceUpdated"
                  class="form-check-input check-lg"
                  type="checkbox"
                  formControlName="isAreaUpdated"
                />
              </div>
              @if (fieldInvalid('isAreaUpdated')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
